
import { defineComponent, ref } from 'vue';
import useDialogVisible from '@/hooks/use-dialog-visible';
import { getLogList } from '@/api/monitor-center-kt';
import type { ILogListItem } from '@/api/monitor-center-kt/type.d';
import { OPERATE_TYPE_LIST } from '@/constant/monitor-center';

export default defineComponent({
  name: 'LogDialog',
  props: {
    modelValue: {
      type: Boolean,
    },
    redisKey: {
      type: String,
      default: () => '',
      require: true,
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const { visible: dialogVisible } = useDialogVisible(props, emit);

    const tableData = ref<ILogListItem[]>([]);

    const handleOpen = async () => {
      const { data } = await getLogList(props.redisKey);
      tableData.value = data;
    };

    const handleClosed = () => {
      tableData.value = [];
    };

    return {
      dialogVisible,
      tableData,
      handleOpen,
      handleClosed,
      OPERATE_TYPE_LIST,
    };
  },
});
